import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ApplicationService } from "src/services/application.service";
import { DefaultComponent } from "../default.component";

@Component({
  selector: "app-screen-auth",
  imports: [RouterOutlet, AsyncPipe],
  templateUrl: "./auth.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./auth.component.less",
})
export class AuthScreenComponent extends DefaultComponent {
  public application = inject(ApplicationService);
}
